import React, { useState } from 'react';
import { auth } from './firebase';  // 假设你有 Firebase 配置文件
import { signInWithEmailAndPassword } from 'firebase/auth';
import './Login.css';  // 引入新的CSS样式
import BackgroundShapes from './BackgroundShapes';  // 导入新的背景组件

const Login = ({ onLogin }) => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [errorMessage, setErrorMessage] = useState('');

    const handleLogin = async (e) => {
        e.preventDefault(); // 阻止默认表单提交行为

        try {
            // Firebase 登录逻辑
            await signInWithEmailAndPassword(auth, email, password);
            onLogin(); // 登录成功后调用回调，更新认证状态
        } catch (error) {
            // 处理错误，更新错误信息
            if (error.code === 'auth/user-not-found') {
                setErrorMessage('用户未找到，请检查您的电子邮件。');
            } else if (error.code === 'auth/wrong-password') {
                setErrorMessage('密码错误，请重新输入。');
            } else {
                setErrorMessage('登录失败，请稍后再试。');
            }
        }
    };

    return (
        <div className="login-container">
            <BackgroundShapes />  {/* 添加背景组件 */}
            <div className="login-card">
                <h1 className="login-logo">loof·tool</h1>
                <p className="login-prompt">请输入您的账户信息进行登陆</p>
                <form onSubmit={handleLogin}>
                    <div className="login-inputs">
                        <input
                            type="email"
                            placeholder="Email"
                            className="login-input"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                        />
                        <input
                            type="password"
                            placeholder="Password"
                            className="login-input"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                        />
                    </div>
                    {errorMessage && <p className="error-message">{errorMessage}</p>}
                    <button type="submit" className="login-btn">
                        登陆
                    </button>
                </form>
            </div>
            <footer className="footer">
                <p>Created & All Copyrights by <span>loof - Li Ye</span></p>  
            </footer>
        </div>
    );
}

export default Login;
